import React from 'react';
import PropTypes from 'prop-types';
import { LuFileSpreadsheet, LuShieldPlus, LuUmbrella } from 'react-icons/lu';
import PageHero from '../../../../components/data/PageHero';
import Button from '../../../../components/ui/Button';
import useInsuranceText from '../insuranceText';

/** Title card of Sigorta Yönetimi with the page actions. */
const InsuranceHeader = ({ onAdd, onExcel }) => {
  const { label } = useInsuranceText();
  return (
    <PageHero
      icon={LuUmbrella}
      gradient="tw-from-rose-400 tw-to-pink-600 tw-shadow-rose-500/30"
      title={label('page.title')}
      subtitle={label('page.subtitle')}
      actionsClassName="tw-grid tw-grid-cols-[auto_minmax(0,1fr)] tw-items-center tw-gap-2 sm:tw-flex sm:tw-flex-wrap lg:tw-justify-end"
    >
      <Button onClick={onExcel} aria-label={label('actions.excel')} title={label('actions.excelHint')} className="max-sm:tw-w-10 max-sm:tw-px-0">
        <LuFileSpreadsheet aria-hidden="true" className="tw-h-4 tw-w-4 tw-text-emerald-600 dark:tw-text-emerald-400" />
        <span className="tw-hidden sm:tw-inline">{label('actions.excel')}</span>
      </Button>
      <Button variant="primary" onClick={onAdd} className="max-sm:tw-w-full">
        <LuShieldPlus aria-hidden="true" className="tw-h-4 tw-w-4" />
        {label('actions.add')}
      </Button>
    </PageHero>
  );
};

InsuranceHeader.propTypes = { onAdd: PropTypes.func.isRequired, onExcel: PropTypes.func.isRequired };

export default InsuranceHeader;
